import { NOTES_ITEM_NAME } from '~/constants/sitecore-keys'

export default (notes, localePath) => notes.map(note => {
    const temp = {
        name: '',
        colors: {
            dark : '#b8584d'
        }
    }
  const fallbackVenue = temp
  const singleVenue = note.venues.length === 1
  const multipleVenues = note.venues.length > 1
  const house = ((singleVenue || multipleVenues) && note.region) ? note.region : fallbackVenue.name
  const houseColor = multipleVenues ? null : fallbackVenue.colors && fallbackVenue.colors.dark
  const category = note.contentCategories.length > 0 ? note.contentCategories[0] : null

  const isVideo = !!(note.headerVideoImageLarge && note.headerVideoUrl)
  const images = isVideo ?
    {
      xlarge: note.headerVideoImageLarge,
      large: note.headerVideoImageLarge,
      medium: note.headerVideoImageSmall,
      small: note.headerVideoImageSmall
    } : {
      xlarge: note.headerImageXlargePng,
      large: note.headerImageLargePng,
      medium: note.headerImageMediumPng,
      small: note.headerImageSmallPng
    }

  return {
    id: note.id,
    articleUrlSlug: note.articleUrlSlug,
    category: category && category.categoryName,
    iconUrl: category && category.categoryIcon.svg,
    fromDate: note.publishDate,
    name: note.title,
    region: note.region,
    house,
    houseColor,
    description: note.shortDescription,
    images,
    isVideo,
    to: localePath({
      path: `/${NOTES_ITEM_NAME}/${note.articleUrlSlug}`
    })
  }
})
